import BaseComponent from "../../components/BaseComponent";
import {
    Alert,
    Button,
    ButtonGroup,
    Div,
    FormItem,
    FormLayout,
    Input,
    NativeSelect, PanelHeader, PanelHeaderButton,
    SplitCol,
    SplitLayout,
    Textarea
} from "@vkontakte/vkui";
import {AddressSuggestions} from "react-dadata";
import * as constants from "../../assets/constants";
import React from "react";
import {ACCESS_DENIED_MESSAGE, AdaptivityContext, isTradeDesigner, userIsTradeChild} from "../../assets/constants";
import {
    Icon24BrowserBack
} from "@vkontakte/icons";
import "./style.css"

import HelpButton from "../../assets/HelpButton";
import SalePointsApi from "../../api/references/salePoints";
import KlientsSelectObject from "./klientsSelectObject";
import PhotoGallery from "../../components/PhotoGallery";
import SalePointMonitoringGalleries from "../../components/SalePointMonitoringGalleries";
import MallSelectObject from "./mallSelectObject";
import SelectObject from "../../assets/SelectObject";

class SalePoint extends BaseComponent {


    state = {
        error_title: '',
        error_trading_floor: '',
        error_photo: '',
        error_address: '',
        error_klient: '',
        error_type: '',
        typeslabels: {},
        error_info: '',
        error_comment: '',
        loading: false,
        currentPopout: null,
    }

    constructor() {
        super();
        this.addressRef = React.createRef()
        this.titleRef = React.createRef();
        this.typeRef = React.createRef();
        this.klientRef = React.createRef();
        this.infoRef = React.createRef();
        this.commentRef = React.createRef();
        this.tradingFloorRef = React.createRef();
        this.state.typeslabels = constants.getSalePointsTypes()
    }

    getMessageType = () => {
        if (this.props.messageType) {
            return this.props.messageType;
        }
        return this.props.item && this.props.item.isMall ? 'setCurrentMall' : 'setCurrentSalePoint';
    }

    normalizeSalePointResponse(data) {
        if (!data || typeof data !== 'object') {
            return null;
        }
        if (data.id != null && data.id !== '') {
            return data;
        }
        if (data.result && data.result.id != null) {
            return data.result;
        }
        if (data.data && data.data.id != null) {
            return data.data;
        }
        if (data.item && data.item.id != null) {
            return data.item;
        }
        return null;
    }

    confirmCloseOpen = (action) => {
        const isClose = action === 'close';
        const alert = <Alert
            onClose={() => this.setState({currentPopout: null})}
            actionsAlign="left"
            actionsLayout="horizontal"
            actions={[
                {
                    title: 'Да',
                    action: () => {
                        this.setState({currentPopout: null});
                        this.performCloseOpen(action);
                    },
                },
                {
                    title: 'Нет',
                    action: () => this.setState({currentPopout: null}),
                },
            ]}
            header={isClose ? 'Закрытие торговой точки' : 'Открытие торговой точки'}
            text={isClose ? 'Торговая точка будет закрыта. Продолжить?' : 'Снять закрытие с торговой точки?'}
        />;
        this.setState({currentPopout: alert});
    }

    performCloseOpen = (action) => {
        const {item} = this.props;
        const req = action === 'close'
            ? SalePointsApi.closeSalePoint(item.id)
            : SalePointsApi.openSalePoint(item.id);
        req.then((res) => {
            const payload = this.normalizeSalePointResponse(res.data);
            if (payload) {
                window.postMessage({type: this.getMessageType(), value: payload});
                window.postMessage({
                    type: 'success',
                    text: action === 'close' ? 'Торговая точка закрыта' : 'Торговая точка открыта',
                    timeout: 2000,
                    hideSpinner: true
                });
                setTimeout(() => window.postMessage({type: 'reloadCurrentList'}), 700);
            } else {
                window.postMessage({
                    type: 'error',
                    text: 'Некорректный ответ сервера',
                    timeout: 5000
                });
            }
        }).catch((err) => {
            const d = err && err.response && err.response.data;
            let text = 'Ошибка при изменении статуса точки';
            if (err && err.response && err.response.status === 403) {
                text = ACCESS_DENIED_MESSAGE;
            } else if (d && typeof d.error === 'string') {
                text = d.error;
            } else if (typeof d === 'string' && d.trim()) {
                text = d;
            } else if (err && err.message) {
                text = err.message;
            }
            window.postMessage({type: 'error', text, timeout: 5000});
        });
    }

    cmdBack = () => {
        this.props.hideForm()
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.addressRef.current) {
            const full_address = this.props.item.mall && this.props.item.mall.uid ? this.props.item.mall.full_address : this.props.item.full_address
            this.addressRef.current.setInputValue(full_address)
        }

    }

    componentDidMount() {
        super.componentDidMount();
        if (this.addressRef.current) {
            const full_address = this.props.item.mall && this.props.item.mall.uid ? this.props.item.mall.full_address : this.props.item.full_address
            this.addressRef.current.setInputValue(full_address)
        }
    }

    // Обработчик изменения изображений
    handleImagesChange = (updatedImages) => {
        const {item} = this.props;
        item.images = updatedImages;
        window.postMessage({type: this.getMessageType(), value: item});
        setTimeout(() => this.setState({}), 100);
    }

    // Обработчик после поворота изображения
    handleImageRotated = (key, updatedImage, updatedImages) => {
        setTimeout(() => this.setState({}), 100);
    }

    // Обработчик после добавления нового изображения
    handleImageAdded = (key, newImage, updatedImages) => {
        setTimeout(() => this.setState({}), 100);
    }

    // Обработчик после добавления множественных изображений
    handleMultipleImagesAdded = (startPosition, images, updatedImages) => {
        console.log(`Добавлено ${images.length} изображений начиная с позиции ${startPosition}`);
        setTimeout(() => this.setState({}), 100);
    }

    receiveMessage = (event) => {
        if (event.data == 'goGetBack') {
            this.cmdBack()
        }
        if (event.data.type == "newMallCreated") {
            console.log(event.data.value)
            this.setMall(event.data.value)
        }
        if (event.data.type == "newKlientCreated") {
            console.log(event.data.value)
            this.setKlient(event.data.value)
        }
        
        // Обработка событий от PhotoGallery
        if (event.data.type === "setSalePointImage") {
            // Одиночное изображение - обрабатывается PhotoGallery автоматически через onImagesChange
            console.log("Получено одиночное изображение для торговой точки");
        }
        
        if (event.data.type === "setSalePointImage_multiple") {
            // Множественные изображения - обрабатывается PhotoGallery автоматически через onImagesChange
            console.log("Получены множественные изображения для торговой точки", event.data.data);
        }
    }



    render() {
        if (!this.props.item) return

        const {item, current_user} = this.props
        if (!Array.isArray(item.images)) {
            item.images = []
        }

        const isDesigner = isTradeDesigner(current_user)
        const isTradeChild = !isDesigner && (item.id > 0 ? userIsTradeChild(current_user, item.user_id) : true)


        return <SplitLayout popout={this.state.currentPopout}>
            <SplitCol>
                {!this.props.no_panel_header && <PanelHeader
                    before={<PanelHeaderButton style={{display: 'inline'}} onClick={() => this.cmdBack()}
                                               key="cmd_back_sale_point"><Icon24BrowserBack/></PanelHeaderButton>}

                >
                    {item.isMall == 1 ? 'Торговый объект' : 'Торговая точка'} {item.title}
                </PanelHeader>}
                <SplitLayout>
                    <SplitCol>
                        <FormLayout>
                            {!item.isMall && <FormItem top="Тип торговой точки"
                                                       status={this.state.error_type == '' ? '' : 'error'}
                                                       bottom={this.state.error_type}
                            >
                                <NativeSelect disabled={!isTradeChild}
                                              style={{
                                                  zIndex: 6,

                                                  height: '30px',

                                              }}
                                              value={item ? item.type_ : ''}
                                              onChange={(e) => this.props.change(e, 'type_')}
                                >
                                    {Object.keys(this.state.typeslabels).map((itemP, indexP) => (
                                        itemP !== 'null' ?
                                            <option value={itemP}>{this.state.typeslabels[itemP]}</option> : ''
                                    ))}</NativeSelect>
                            </FormItem>}
                            {!item.isMall && <KlientsSelectObject current_user={current_user}
                                                                  title="Клиент" app="klients"
                                                                  getRootRef={this.klientRef}
                                                                  act="getKlientsjson"
                                                                  className={'selectObjectDropdownStyle'}
                                                                  style={{minHeight: '33px'}}
                                                                  error={this.state.error_klient}
                                                                  modal_title="Клиенты"
                                                                  create_action
                                                                  selectObject={this.setKlient}
                                                                  default={item.klient}
                                                                  params={`show_all=1&no_empty_inn=1`}
                                                                  mode="outline"
                                                                  size="s"
                                                                  disabled={!isTradeChild}
                                                                  create_action={isTradeChild}

                            />}
                            {!item.isMall && <MallSelectObject
                                className={'selectObjectDropdownStyle'}
                                current_user={current_user}
                                title={`Торговый объект`}
                                style={{minHeight: '33px'}}
                                app="salePoints"
                                act="getList"
                                params={`isMalls=1`}
                                default={item && item.mall ? item.mall : undefined}
                                modal_title="Список торговых объектов"
                                mode="outline"
                                size="s"
                                selectObject={this.setMall}
                                disabled={!isTradeChild}
                                create_action={isTradeChild}


                            />}
                            <FormItem top={item.isMall ? "Название торгового объекта" : "Вывеска"}
                                      status={this.state.error_title == '' ? '' : 'error'}
                                      bottom={this.state.error_title}
                                      getRootRef={this.titleRef}
                            >
                                <Input type="text" value={item.title} disabled={!isTradeChild}
                                       onChange={e => this.props.change(e, 'title')}/>
                            </FormItem>

                            {!item.isMall && <FormItem top="Номер торгового зала"
                                                       status={this.state.error_trading_floor == '' ? '' : 'error'}
                                                       bottom={this.state.error_trading_floor}
                                                       getRootRef={this.tradingFloorRef}
                            >
                                <Input type="text" value={item.trading_floor} disabled={!isTradeChild}
                                       onChange={e => this.props.change(e, 'trading_floor')}/>
                            </FormItem>}
                            <FormItem
                                top={[!item.isMall ? "Адрес торговой точки" : "Адрес торгового объекта ", item.mall && (item.mall.uid && item.mall.uid > 0 || item.mall.id && item.mall.id > 0) ?
                                    <HelpButton text="Адрес взят из указанного ТЦ"/> : '']}
                                status={this.state.error_address == '' ? '' : 'error'}
                                bottom={this.state.error_address}

                            >
                                <AddressSuggestions ref={this.addressRef}
                                                    onChange={e => this.props.change(e, 'full_address')}
                                                    token="5367f393d0040cdc339492986bea8f13ebeec2a5"
                                                    inputProps={{
                                                        disabled: !isTradeChild || (item.mall && (item.mall.uid && item.mall.uid > 0 || item.mall.id && item.mall.id > 0)) ? true : false
                                                    }}
                                />
                            </FormItem>

                            {!item.isMall && <FormItem top="Подробная информация"
                                                       status={this.state.error_info == '' ? '' : 'error'}
                                                       bottom={this.state.error_info}
                                                       getRootRef={this.infoRef}
                            >
                                <Textarea rows="5" value={item.info} onChange={e => this.props.change(e, 'info')}
                                          disabled={!isTradeChild}
                                          placeholder="Подробности к адресу, как найти, какой этаж/кабинет и т.д."/>
                            </FormItem>}
                            <FormItem top="Примечания"
                                      status={this.state.error_comment == '' ? '' : 'error'}
                                      bottom={this.state.error_comment}
                                      getRootRef={this.commentRef}
                            >
                                <Textarea rows="5" value={item.comment} onChange={e => this.props.change(e, 'comment')}
                                          disabled={!isTradeChild}
                                          placeholder="Важная информация, заметки"/>
                            </FormItem>
                            <SelectObject
                                className={'selectObjectDropdownStyle'}
                                current_user={current_user}
                                disabled={!isTradeChild || (current_user && current_user.position_id && (![2, 3].includes(current_user.position_id)))}
                                title={`Ответственный менеджер`}
                                style={{minHeight: '33px'}}
                                app="users"
                                act="getList"
                                params={`address_program_only=1`}
                                default={item && item.manager ? item.manager : undefined}
                                modal_title="Список менеджеров"
                                mode="outline"
                                size="s"
                                selectObject={this.setManager}

                            />
                        </FormLayout>
                    </SplitCol>
                </SplitLayout>
                {!item.isMall && item.id > 0 && isTradeChild && (item.closed == 1 || item.can_close) &&
                    <Div style={{paddingLeft: 12, paddingRight: 12}}>
                        {item.closed == 1 &&
                            <Div style={{
                                padding: 12,
                                backgroundColor: 'rgba(245, 210, 214, 0.55)',
                                borderRadius: 8,
                                marginBottom: 12
                            }}>
                                <b>Закрыта</b>
                                {item.closed_at ? <> {item.closed_at}</> : null}
                                {item.closed_by && item.closed_by.title ? <>, {item.closed_by.title}</> : null}
                            </Div>}
                        {item.can_close === true &&
                            <ButtonGroup mode="horizontal" style={{marginBottom: 12}}>
                                {item.closed == 1
                                    ? <Button mode="commerce" size="m"
                                              onClick={() => this.confirmCloseOpen('open')}>Открыть точку</Button>
                                    : <Button mode="destructive" size="m"
                                              onClick={() => this.confirmCloseOpen('close')}>Закрыть точку</Button>}
                            </ButtonGroup>}
                    </Div>}
                {!item.isMall && item.id > 0 && (
                    <SalePointMonitoringGalleries
                        sp_id={item.id}
                        base_url={this.props.base_url}
                    />
                )}
                {!item.isMall && 
                    <div>
                        <Div>
                            <p style={{color: 'red'}}>{this.state.error_photo}</p>
                        </Div>
                        <PhotoGallery
                            images={item.images}
                            title={`Фотографии ${!item.isMall ? 'торговой точки' : 'торгового объекта'}`}
                            base_url={this.props.base_url}
                            usePhotoWrapper={true}
                            destination="brands"
                            eventName="setSalePointImage"
                            multipleEventName="setSalePointImage_multiple"
                            readOnly={!isTradeChild}
                            fancyboxGroup={`gallerySalePoint-${item.id || 'new'}`}
                            onImagesChange={this.handleImagesChange}
                            onImageRotated={this.handleImageRotated}
                            onImageAdded={this.handleImageAdded}
                            onMultipleImagesAdded={this.handleMultipleImagesAdded}
                        />
                    </div>
                }


                <Div className={AdaptivityContext.isMobile && !this.props.noStickedActions ? "action-board" : ''}>
                    <ButtonGroup mode="horizontal" stretched style={{justifyContent: 'end'}}>
                        <Button stretched size={AdaptivityContext.isMobile ? 'm' : 'l'}
                                style={{maxWidth: '50%'}}
                                onClick={() => this.cmdBack()}>Отмена</Button>
                        <Button stretched size={AdaptivityContext.isMobile ? 'm' : 'l'}
                                style={{maxWidth: '50%'}} loading={this.state.loading}
                                disabled={this.state.loading || !isTradeChild}
                                onClick={() => this.save()}>Сохранить</Button>
                    </ButtonGroup>
                </Div>
            </SplitCol>
        </SplitLayout>
    }

    setMall = (mall) => {
        if (!mall.uid) {
            return
        }
        const old = this.props.item

        old.mall_id = mall.uid
        old.mall = mall
        old.full_address = mall.full_address
        this.addressRef.current.setInputValue(old.full_address)
        window.postMessage({type: this.getMessageType(), value: old})
        setTimeout(() => this.setState({}), 100);
    }
    setManager = (manager) => {
        if (!manager.uid) {
            return
        }
        const old = this.props.item

        old.manager_id = manager.uid
        old.maneger = manager

        window.postMessage({type: this.getMessageType(), value: old})

    }
    setKlient = (klient) => {
        if (!klient.uid) {
            return
        }
        const old = this.props.item

        old.klient_id = klient.uid
        old.klient = klient

        window.postMessage({type: this.getMessageType(), value: old})
    }

    save = () => {
        let errors = 0;
        const {item, current_user} = this.props
        if (isTradeDesigner(current_user)) {
            window.postMessage({
                type: 'error',
                text: ACCESS_DENIED_MESSAGE,
                timeout: 3000
            })
            return
        }
        this.setState({
            error_title: '',
            error_address: '',
            error_type: '',
            error_klient: '',
            error_info: '',
            error_comment: '',
            error_photo: ''
        })
        let lastErrorRef = null;

        let imgCnt = 0

        if (Array.isArray(item.images)) {
            item.images.forEach(image_item => {
                if (image_item && image_item.hasImage) imgCnt++
            })
        }


        if (imgCnt == 0 && !item.isMall) {
            if (item.isMall) {
                this.setState({error_photo: 'Необходимо сделать хотя бы одну фотографию ТЦ'})
            } else {
                this.setState({error_photo: 'Необходимо сделать хотя бы одну фотографию торговой точки'})
            }
            errors++
        }
        if (!item.title || item.title.trim() == '') {
            this.setState({error_title: 'Необходимо заполнить вывеску'})
            lastErrorRef = this.titleRef
            errors++
        }
        if (!item.isMall && (!item.klient || !item.klient.uid > 0)) {
            errors++
            this.setState({error_klient: "Необходимо указаать клиента!"})
            lastErrorRef = this.klientRef
        }
        if (!item.isMall && (!item.type_ || item.type_ == '')) {
            this.setState({error_type: 'Необходимо заполнить тип торговой точки'})
            errors++
            lastErrorRef = this.typeRef
        }
        if ((!item.full_address || item.full_address.trim() == '') && (!item.mall || !item.mall.uid > 0)) {
            this.setState({error_address: 'Необходимо заполнить адрес и выбрать его из выпадающего списка'})
            errors++
            lastErrorRef = this.addressRef
        } else if (item.mall && item.mall.uid > 0) {
            item.full_address = item.mall.full_address
        }

        if (errors > 0) {
            setTimeout(() => {
                if (lastErrorRef?.current?.scrollIntoView) {
                    lastErrorRef.current.scrollIntoView({behavior: "smooth", block: "center"});
                }
            }, 100);

            return
        }
        this.setState({loading: true})
        SalePointsApi.saveSalePoint(item).then(res => {
            this.setState({loading: false})
            if (item.isMall == 1 || this.props.no_reload_klient) {
                window.postMessage('resetDefaultSelected')
                res.data.descr = res.data.full_address
                setTimeout(() => {
                    window.postMessage({
                        type: this.getMessageType(),
                        value: this.props.no_reload_klient ? res.data : null,
                        isMall: item.isMall
                    })
                    if (this.props.onCreate) {
                        this.props.onCreate(res.data)
                    }
                    setTimeout(() => window.postMessage({type: 'reloadCurrentList'}), 700)
                }, 600)
            } else {
                window.postMessage({type: 'reloadCurrentKlient'})
            }

        }).catch((err) => {
            this.setState({loading: false})
            const d = err && err.response && err.response.data
            let text = 'Ошибка при сохранении торговой точки'
            if (err && err.response && err.response.status === 403) {
                text = ACCESS_DENIED_MESSAGE
            } else if (d && typeof d.error === 'string') {
                text = d.error
            } else if (typeof d === 'string' && d.trim()) {
                text = d
            } else if (err && err.message) {
                text = err.message
            }
            window.postMessage({type: 'error', text, timeout: 5000})
        })

    }
}

export default SalePoint